import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import Box from "@mui/material/Box";
// import Collapse from "@mui/material/Collapse";
// import IconButton from "@mui/material/IconButton";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../firebase-config";
import { Typography, Box, Stack, Button } from "@mui/material";
import * as XLSX from "xlsx";

function Row(props) {
  // const { data, total, name } = props;
  const { total, name, currency } = props;

  // const [open, setOpen] = React.useState(true);
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        {/* <TableCell>
          {data !== undefined ? (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          ) : null}
        </TableCell> */}
        <TableCell component="th" scope="row">
          {name}
        </TableCell>
        <TableCell align="right">
          {currency}. {total.toLocaleString()}
        </TableCell>
      </TableRow>
      {/* {data !== undefined ? (
        <TableRow>
          <TableCell
            style={{
              paddingBottom: 0,
              paddingTop: 0,
              paddingRight: 0,
              paddingLeft: 0,
            }}
            colSpan={6}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ marginLeft: 0 }}>
                <Table size="medium" aria-label="purchases">
                  <TableBody>
                    {Object.keys(data).map((key) => {
                      return (
                        <TableRow>
                          <TableCell align="center">{key}</TableCell>
                          <TableCell align="right">
                            Ksh. {data[key].toLocaleString()}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      ) : null} */}
    </React.Fragment>
  );
}

export default function BalanceSheet({
  id,
  year,
  period,
  company_name,
  periodIndex,
}) {
  const [dataId, setDataId] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);

  const tableRef = React.useRef(null);

  /* Callback invoked when the button is clicked */
  const xport = React.useCallback(async () => {
    /* Create worksheet from HTML DOM TABLE */
    // const table = document.getElementById("Table2XLSX");
    const table = tableRef.current;
    const wb = XLSX.utils.table_to_book(table);

    /* Export to file (start a download) */
    XLSX.writeFile(wb, `Balance Sheet ${company_name} ${period} ${year}.xlsx`);
  }, [company_name, period, year]);

  async function getBalanceSheet({ id, year, period, periodIndex }) {
    setLoading(true);
    const q = query(
      collection(db, "companies-financials"),
      where("company-id", "==", id),
      where("year", "==", year),
      where("type", "==", "Balance Sheet"),
      where("period", "==", period),
      where("period-index", "==", periodIndex)
    );
    let idDoc;
    const allDocs = [];
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      allDocs.push(doc.data());
      idDoc = doc.id;
    });
    setData(allDocs[0]);
    setDataId(idDoc);
    setLoading(false);
  }

  useEffect(() => {
    getBalanceSheet({ id, year, period, periodIndex });
  }, [id, period, year, periodIndex]);

  return loading ? (
    <h1>Loading</h1>
  ) : data === undefined ? (
    <Typography>No Data Available</Typography>
  ) : (
    <>
      {!process.env.NODE_ENV || process.env.NODE_ENV === "development" ? (
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          <Typography>{dataId}</Typography>
        </Stack>
      ) : (
        <></>
      )}
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="flex-start"
        spacing={2}
      >
        <Button
          variant="outlined"
          onClick={xport}
          size="small"
          color="secondary"
        >
          Export to Excel
        </Button>
      </Stack>

      <Box
        sx={{
          marginBottom: "10px",
        }}
      />
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table" ref={tableRef}>
          <TableHead
            sx={{
              backgroundColor: "black",
            }}
          >
            <TableRow>
              {/* <TableCell /> */}
              <TableCell>Breakdown</TableCell>
              <TableCell align="right">{year}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data["Total Non-Current Assets"] !== undefined ? (
              <Row
                name="Non-Current Assets"
                key="Non-Current Assets"
                // data={data["non-current-assets"]}
                total={data["Total Non-Current Assets"]}
                currency={data["currency"]}
              />
            ) : (
              <></>
            )}

            {data["Total Current Assets"] !== undefined ? (
              <Row
                name="Current Assets"
                key={"Current Assets"}
                // data={data["current-assets"]}
                total={data["Total Current Assets"]}
                currency={data["currency"]}
              />
            ) : (
              <></>
            )}

            <Row
              name="Total Assets"
              key="Total Assets"
              total={data["Total Assets"]}
              currency={data["currency"]}
            />

            {data["Total Non-Current Liabilities"] !== undefined ? (
              <Row
                name="Non-Current Liabilities"
                key="Non-Current Liabilities"
                // data={data["non-current-liabilities"]}
                total={data["Total Non-Current Liabilities"]}
                currency={data["currency"]}
              />
            ) : (
              <></>
            )}

            {data["Total Current Liabilities"] !== undefined ? (
              <Row
                name="Current Liabilities"
                key={"Current Liabilities"}
                // data={data["current-liabilities"]}
                total={data["Total Current Liabilities"]}
                currency={data["currency"]}
              />
            ) : (
              <></>
            )}

            <Row
              name="Total Liabilities"
              key="Total Liabilities"
              total={data["Total Liabilities"]}
              currency={data["currency"]}
            />

            <Row
              name="Equity"
              key={"Equity"}
              // data={data["equity"]}
              total={data["Total Shareholder's Equity"]}
              currency={data["currency"]}
            />

            <Row
              name={"Total Equity & Liabilities"}
              key={"Total Equity & Liabilities"}
              total={data["Total Equity & Liabilities"]}
              currency={data["currency"]}
            />
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
